import { useContext } from 'react'
import { NotificationContext } from 'UI/Components'

export const useNotification = () => useContext(NotificationContext)
